import React, { useEffect, useState } from "react";
import Table from "../../components/table/Table";
import Selector from "../../components/dropdown/commonDropdown/Selector";
import moment from "moment";
import SwalServices from "../../services/swalServices/SwalServices";
import { axiosGetAuthorize, axiosPostAuthorize } from "../../services/axiosServices/AxiosRequests";

const XeroPaymentUpdate = () => {
  const swalServices = new SwalServices();
  const statusList = [
    {
      value: 1,
      label: "Pending Approval",
    },
    {
      value: 2,
      label: "Completed",
    },
    {
      value: 3,
      label: "Approved",
    },
  ];
  const [datasource, setDatasource] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isApproval, setIsApproval] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [totalResults, setTotalResults] = useState(25);
  const [pagination, setPagination] = useState({
    pageNo: 1,
    pageSize: 10,
    orderByColumn: "",
    orderFlag: 0,
    searchText: "",
    reconcilationStatus: "",
    searchByCompany: "",
  });

  const handlePagination = (newPagination) => {
    let updatedPagination = { ...pagination, ...newPagination };
    setPagination(updatedPagination);
    getPaymentReconcilationListRecord(updatedPagination);
  };

  const getPaymentReconcilationListRecord = async (newPagination) => {
    try {
      setIsLoading(true);
      const request = {
        pageNo: newPagination.pageNo,
        pageSize: newPagination.pageSize,
        orderByColumn: newPagination.orderByColumn,
        orderFlag: newPagination.orderFlag,
        searchText: newPagination.searchText,
        reconcilationStatus: newPagination.reconcilationStatus,
        searchByCompany: newPagination.searchByCompany,
      };
      const response = await axiosPostAuthorize("Booking/GetPaymentReconcilationList", request);
      if (response?.statusCode === 200 && response?.responseItem) {

        let details = response?.responseItem?.responseContent?.itemList?.map((key) => ({
          ...key,
          registrationDate: moment(key.registrationDate).format("DD MMM YYYY"),
          organisationUEN: key.organisationUEN === null || key.organisationUEN === "" ? "-" : key.organisationUEN,
          organisationName: key.organisationName === null || key.organisationName === "" ? "-" : key.organisationName,
        }));
        setDatasource(details);
        setTotalResults(response?.responseItem?.responseContent?.totalCount || 0);
      } else {
        swalServices.Error(response?.message);
      }
    } catch (error) {
      swalServices.Error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = () => {
    getPaymentReconcilationListRecord(pagination);
  };

  const handleClear = () => {
    const clearedPagination = {
      pageNo: 1,
      pageSize: 10,
      orderByColumn: "",
      orderFlag: 0,
      searchText: "",
      reconcilationStatus: "",
      searchByCompany: "",
    };
    setPagination(clearedPagination);
    getPaymentReconcilationListRecord(clearedPagination);
  };

  const handleUpdate = async () => {
    try {
      setIsUpdating(true);
      const response = await axiosPostAuthorize("Xero/GetAllPaidInvoicesForEvent");
      if (response?.responseItem?.responseContent?.message?.includes("No matching PAID invoices found.")) {
        swalServices.Alert("No PAID invoices found in Xero.")
      }
      else {
        swalServices.Success("Updated xero invoice.")
        getPaymentReconcilationListRecord(pagination);
      }
    } catch (error) {
      swalServices.Error("Something went wrong");
    } finally {
      setIsUpdating(false);
    }
  };



  const handleApprove = async (id) => {
    setIsApproval(id);
    try {
      const response = await axiosGetAuthorize(`Booking/ApproveTotalPaidAmountInReconcilation?id=${id}&IsFromAPI=true`);
      if (response.statusCode === 200 && response.responseItem != null) {
        if (response.responseItem.responseContent != null) {
          swalServices.Success("Approval completed.");
          setIsApproval(null);
        }
      } else {
        swalServices.Error(response.message);
      }
    } catch (error) {
      swalServices.Error("Something went wrong");
    } finally {
      setIsApproval(null);
      handleClear();
    }
  };

  let actionColumnRenderer = (element, index, value, data) => {
    return (
      <td key={data.bookingId}>
        <button className="edit-btn" disabled={!(data.paymentProofStatus == "Completed")}
          onClick={() => handleApprove(data.bookingId, index)}
        >
          {isApproval === data.bookingId ? "Loading..." : "Approve"}
        </button>
        {/* <button className="delete-btn">Delete</button> */}
      </td>
    );
  };

  useEffect(() => {
    getPaymentReconcilationListRecord(pagination);
  }, []);

  return (
    <div className="main-body-section">
      <div className="xero-payment-update custom-card">
        <div className="payment-update-filter row">
          <div className="status-input col-10">
            <div className="field-group">
              <label>Search Invoice</label>
              <input type="text" value={pagination.searchText} onChange={(e) => setPagination({ ...pagination, searchText: e.target.value })}></input>
            </div>
            <div className="field-group">
              <label>Search Company Name</label>
              <input type="text" value={pagination.searchByCompany} onChange={(e) => setPagination({ ...pagination, searchByCompany: e.target.value })}></input>
            </div>
            <div className="field-group">
              <label>Status</label>
              <Selector
                options={statusList}
                closeMenuOnSelect={true}
                hideSelectedOptions={false}
                onChange={(selectedOption) => setPagination({ ...pagination, reconcilationStatus: selectedOption.label })}
                allowSelectAll={false}
                value={statusList.find(option => option.label === pagination.reconcilationStatus) || null}
                drpIdentity="status"
              />
            </div>
          </div>
          <div className="col-2 xero-right-side-btn mt-0 mb-3 ">
            <button className="search-btn" onClick={handleSearch}>Search</button>
            <button className="clear-btn" onClick={handleClear}>Clear</button>
          </div>
        </div>
        <div className="update-btn-sec">
          <button className="update-btn" onClick={handleUpdate}>{isUpdating ? "Loading..." : "Update"}</button>
        </div>
        <div className="payment-update-list">
          <div className="mt-10 payment-reconcilation-tble">
            <div className="mt-10 payment-reconcilation-tble">
              <Table
                columns={[
                  { name: "registrationDate", title: "Registration Date" },
                  { name: "invoiceNumber", title: "Invoice No" },
                  { name: "organisationName", title: "Company Name" },
                  { name: "organisationUEN", title: "Company UEN" },
                  { name: "contactPerson", title: "Contact Person" },
                  { name: "paymentVia", title: "Payment Via" },
                  { name: "paymentProofStatus", title: "Status" },
                  { name: "paymentProofId", title: "Action" },
                ]}
                pagination={pagination}
                rows={datasource}
                sortingColumns={["registrationDate", "invoiceNumber", "organisationName", "organisationUEN", "paymentProofStatus"]}
                isLoading={isLoading}
                totalResults={totalResults}
                totalCount={totalResults} // for the pagination to work properly, totalCount should be equal to totalResults
                setPagination={(data) => handlePagination(data)}
                customScope={[
                  {
                    column: "paymentProofId",
                    renderTableData: actionColumnRenderer,
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default XeroPaymentUpdate;
